export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref7813.446a0e02.jpg";